import { css } from '@emotion/css';

export const editorStyles = css`
  min-height: 13.7rem;
  max-height: 44rem;

  .lygo-editor *::selection {
    color: var(--text-highlight);
    background: var(--bg-highlight);
  }

  .lygo-editor {
    padding: 12px 16px;
    width: 100%;

    ul,
    ol {
      padding-inline-start: 1.5em;
    }
    ol {
      list-style-type: decimal;
    }
    ul {
      list-style-type: disc;
    }
    ul li,
    ol li {
      padding-inline-start: 0.5em;
    }
  }
`;
